import Icon from 'veui/components/Icon'
import { IconToolbox } from 'dls-icons-vue'

Icon.register('toolbox', IconToolbox)
